export class Sender
{
    public Id = "";
}
